/**
 * Minutes of Meeting — the Studio shell.
 *
 * The Classic two-pane page (config rail + read-only preview) was retired on
 * 2026-07-22 after the filing-readiness QA campaign passed: MinutesStudio is
 * now the only shell. It owns everything Classic did — the full meeting form
 * (Details overlay), AI generation, inline editing, numbered PDF/DOCX export
 * with the statutory page ledger, saved-draft restore and AI-chat handoff —
 * plus the copilot dock and the server-synced working draft.
 */
import { useEffect } from 'react';
import { markOnboardingStep } from '../utils/onboarding';
import AppLayout from '../components/layout/AppLayout';
import MinutesStudio from '../components/minutes/MinutesStudio';

export default function MinutesPage() {
  // Getting-started runway: reaching any drafting surface completes the step.
  useEffect(() => { markOnboardingStep('visited-drafting'); }, []);

  return (
    <AppLayout pageTitle="Minutes Studio" fullHeight>
      <MinutesStudio />
    </AppLayout>
  );
}
